module.exports = __webpack_public_path__ + "static/media/segurosuy.991ad171.png";